import React from 'react';
import { Typography, WarningIcon } from '@routific/hive/v5';
import { useTranslation } from 'react-i18next';
import { InlineWarning } from './styles';

export const LandlinePhoneNumberWarning = () => {
  const { t } = useTranslation('common');

  return (
    <InlineWarning data-testid="landline-phone-number-warning">
      <WarningIcon size="sm" tone="warning" />
      <Typography variant="caption" tone="warning">
        {t('visitFields.phone.phoneNumberValidation.landlineWarning')}
      </Typography>
    </InlineWarning>
  );
};
